import styled from 'styled-components';
import React from 'react';

import { FlexRow, HeaderText, PageTile } from '@make-software/cspr-design';
import { Container } from '@/components';

const PageContentSection = styled.section(({ theme }) =>
  theme.withMedia({
    maxWidth: ['100%', '720px', '1200px'],
    width: '100%',
    margin: '0 auto',
    padding: '0 12px',
    paddingTop: '48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  })
);

const HeaderRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  })
);

const PolicyContent = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: `20px`,
    lineHeight: '1.6',
    '& h2': {
      margin: '8px 0 0',
      fontSize: '20px',
    },
    '& p': {
      margin: 0,
    },
  })
);

const PrivacyPolicyScene = () => {
  return (
    <Container>
      <PageContentSection>
        <HeaderRow>
          <HeaderText size={2}>Privacy Policy</HeaderText>
        </HeaderRow>

        <PageTile>
          <PolicyContent>
            <p>
              <em>Last updated: January 27, 2026</em>
            </p>
            <p>
              This Privacy Policy applies to the ChainMail demo application ("ChainMail").
            </p>
            <h2>No Data Collection</h2>
            <p>
              ChainMail does <strong>not</strong> collect, store, or process any personal data. It
              operates as a demonstration of decentralized, encrypted on-chain messaging and does
              not interact with centralized servers or databases.
            </p>
            <h2>No Liability</h2>
            <p>
              This is a demonstration project provided <strong>as-is</strong>, without any warranty
              of functionality, availability, or fitness for a particular purpose. By using
              ChainMail, you agree that the developers or maintainers are{' '}
              <strong>not liable</strong> for any loss, damage, or consequence resulting from its
              use.
            </p>
            <h2>Use at Your Own Risk</h2>
            <p>
              ChainMail is an exploration of the idea of using blockchain wallets for encrypted
              communication. Do not use it for sensitive, confidential, or production communications
              until it is explicitly marked as stable.
            </p>
            <h2>Contact</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact the ChainMail
              contract owner account via ChainMail.
            </p>
          </PolicyContent>
        </PageTile>
      </PageContentSection>
    </Container>
  );
};

export default PrivacyPolicyScene;
